import { Alert, Dialog, TextV2 } from '@insights-ltd/design-library/components';
import { Box } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

type SpecialHandlingWarningModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  isSaving: boolean;
};

const Content = () => {
  const { t } = useTranslation();
  return (
    <>
      <TextV2 color="textSecondary">
        <Trans
          i18nKey="ui.event-management.special-handling.organisations.add.confirmation.modal.info"
          components={{
            stress: <TextV2 variant="bodyBold" color="textSecondary" />,
          }}
        />
      </TextV2>
      <Box
        sx={{
          mt: 2,
        }}
      >
        <Alert
          severity="error"
          message={t(
            'ui.event-management.special-handling.organisations.add.confirmation.modal.warning',
          )}
        />
      </Box>
    </>
  );
};

export const SpecialHandlingWarningModal = ({
  isOpen,
  onClose,
  onSubmit,
  isSaving,
}: SpecialHandlingWarningModalProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      disablePrimaryButton={isSaving}
      open={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      title={t(
        'ui.event-management.special-handling.organisations.add.confirmation.modal.title',
      )}
      content={<Content />}
      primaryButtonText={t(
        'ui.event-management.special-handling.organisations.add.confirmation.modal.confirm',
      )}
      secondaryButtonText={t(
        'ui.event-management.special-handling.organisations.add.confirmation.modal.cancel',
      )}
    />
  );
};
